import { render, staticRenderFns } from "./IconAddZone.vue?vue&type=template&id=f0c4080c&"
import script from "./IconAddZone.vue?vue&type=script&lang=js&"
export * from "./IconAddZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports